import ForgotPasswordForm from 'components/login/ForgotPassword';

function ForgotPasswordPage() {
  return (
    <section>
      <ForgotPasswordForm />
    </section>
  );
}

export default ForgotPasswordPage;
